import React, { useEffect, useState } from "react";
import axios from "axios";
import { Phone, MessageCircle, RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LeadsAdmin() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const r = await axios.get(`${API}/leads`);
      setLeads(r.data || []);
      setError(null);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="min-h-screen bg-slate-50 py-12 px-5 md:px-10">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="font-display text-3xl font-bold text-slate-950">Leads</h1>
            <p className="text-slate-500 text-sm mt-1">All inquiries from launchmitra.in</p>
          </div>
          <button
            onClick={load}
            data-testid="refresh-leads-btn"
            className="inline-flex items-center gap-2 h-10 px-4 rounded-full bg-slate-950 text-white text-sm font-semibold"
          >
            <RefreshCw className="w-4 h-4" /> Refresh
          </button>
        </div>

        {error && <div className="mt-6 p-4 bg-rose-50 text-rose-700 rounded-xl text-sm" data-testid="leads-error">{error}</div>}

        <div className="mt-6 rounded-2xl bg-white border border-slate-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-100 text-slate-700">
              <tr>
                <th className="text-left p-3.5 font-semibold">Name</th>
                <th className="text-left p-3.5 font-semibold">Phone</th>
                <th className="text-left p-3.5 font-semibold">Business</th>
                <th className="text-left p-3.5 font-semibold">Plan</th>
                <th className="text-left p-3.5 font-semibold">Lang</th>
                <th className="text-left p-3.5 font-semibold">When</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={6} className="p-8 text-center text-slate-500">Loading…</td></tr>
              ) : leads.length === 0 ? (
                <tr><td colSpan={6} className="p-8 text-center text-slate-500" data-testid="no-leads">No leads yet.</td></tr>
              ) : leads.map((l, i) => (
                <tr key={l.id || i} className="border-t border-slate-100 hover:bg-slate-50" data-testid={`lead-row-${i}`}>
                  <td className="p-3.5 font-medium text-slate-900">{l.name}</td>
                  <td className="p-3.5">
                    <div className="flex items-center gap-2">
                      <a href={`tel:${l.phone}`} className="text-blue-600 hover:underline inline-flex items-center gap-1">
                        <Phone className="w-3.5 h-3.5" /> {l.phone}
                      </a>
                      <a href={`https://wa.me/${(l.phone || "").replace(/\D/g, "")}`} target="_blank" rel="noopener noreferrer" className="text-emerald-600">
                        <MessageCircle className="w-3.5 h-3.5" />
                      </a>
                    </div>
                  </td>
                  <td className="p-3.5 text-slate-700">{l.business_type || "-"}</td>
                  <td className="p-3.5 text-slate-700">{l.plan || "-"}</td>
                  <td className="p-3.5 text-slate-500 uppercase text-xs">{l.language || "en"}</td>
                  <td className="p-3.5 text-slate-500 text-xs">{l.created_at ? new Date(l.created_at).toLocaleString() : ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
